/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { styled, SxProps } from '@mui/material/styles';

const Header = styled(TableHead)(() => ({
  background: 'rgba(241, 238, 243, 1)',
  border: '1px solid rgba(223, 228, 242, 1)',
  height: '32px',
  fontFamily: 'Poppins'
}));

const HeaderCell = styled(TableCell)(() => ({
  fontFamily: 'Poppins',
  fontSize: '12px',
  color: 'rgba(126, 133, 142, 1)',
  textTransform: 'uppercase',
  borderLeft: 'none',
  borderRight: 'none'
}));

const Row = styled(TableRow)(() => ({
  height: '32px'
}));

const InnerCell = styled(TableCell)(() => ({
  height: '60px',
  fontFamily: 'Poppins',
  color: 'rgba(23, 30, 40, 1)',
  borderLeft: 'none',
  borderRight: 'none',
  borderTop: '1px solid rgba(223, 228, 242, 1)',
  borderBottom: '1px solid rgba(223, 228, 242, 1)'
}));

export interface TwTableColumn {
  id: string;
  label: string | React.ReactNode;
  minWidth?: number | string;
  align?: 'right' | 'center' | 'left';
  format?: (value: number) => string;
  maxWidth?: number | string;
}

export interface TwTableData {
  [key: string]: undefined | any;
  handleClick?: {
    onClick: () => void;
    // it's neccessary send a  and ignore list for check if the event is allowed in the cell
    ignore: string[];
  };
}

export interface TwTableProps {
  /**
   * Title of the dialog if any.
   */
  title?: string;
  /**
   * The columns for the table
   */
  columns: TwTableColumn[];
  /**
   * Table data
   */
  data: TwTableData[];
  /**
   * Table classes
   */
  className?: string;
  /**
   * Table styles
   */
  sx?: SxProps;
}

const TwTable: React.FC<TwTableProps> = ({ title, columns, data, className, sx }): JSX.Element => {
  const getRows = (data: TwTableData[]): any[] => {
    const rows: any[] = [];
    data.forEach((item) => {
      rows.push(item);
    });
    return rows;
  };

  const rows = data && getRows(data);

  return (
    <TableContainer component={Paper} className="tid-table__wrapper">
      <Table
        sx={{ minWidth: 700, ...sx }}
        size="small"
        aria-label={title}
        className={`tid-table ${className ?? ''}`}
      >
        <Header className="tid-table__header">
          <Row>
            {columns &&
              columns.map((column) => (
                <HeaderCell
                  className="tid-table__column"
                  key={column.id}
                  align={column.align || undefined}
                  style={{ minWidth: column.minWidth, maxWidth: column.maxWidth }}
                >
                  {column.label}
                </HeaderCell>
              ))}
          </Row>
        </Header>
        <TableBody className="tid-table__body">
          {rows.map((row, i) => {
            return (
              <Row className="tid-table__row" tabIndex={-1} key={`${row.id}-${i}`}>
                {columns &&
                  columns.map((column) => {
                    const value = row[column.id];
                    let onClick;
                    if (row?.handleClick !== undefined) {
                      if (!row.handleClick.ignore.includes(column.id)) {
                        onClick = row.handleClick.onClick;
                      }
                    }
                    return (
                      <InnerCell
                        className="tid-table__column-data"
                        key={column.id}
                        align={column.align || undefined}
                        onClick={onClick}
                      >
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </InnerCell>
                    );
                  })}
              </Row>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TwTable;
